<div class="home-page">

  <!-- Hero Section -->
  <section class="fm-hero-section fm-hero-image" style="background-image: url('images/homepage/hero-bg.png'); background-size: cover; background-position: center;">
    <div class="container-xl h-100">
      <div class="row align-items-center h-100">
        <div class="col-lg-10 col-xl-9 col-xxl-8">
          <div class="fm-layout-space fm-herocontent">
            <div class="fm-title">
              <h2 class="fm-head-66">Preserve Life Stories.<br/>Share Them Forever.</h2>
            </div>
            <p class="fm-large mb-0">
              Capture the wisdom, love, and legacy of your life through video, audio, and photos.
              Guided prompts make storytelling effortless. Your memories, preserved for generations.
            </p>
            <div class="fm-btn-group">
              <a routerLink="/register" class="fm-common-btn">Start Preserving Memories</a>
              <a href="#fmHowItWorks" class="fm-common-btn fm-border-btn fm-white-btn">See How it Works</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- Preserve Your Legacy Section -->
  <section id="fmFeatures" class="fm-layout-space fm-light-bg fm-preserve-section">
    <div class="container-xl">
      <div class="row">
        <div class="col-12 text-center">
          <div class="fm-title">
            <h2 class="fm-head-44"><span>Everything You Need to Preserve Your Legacy</span></h2>
          </div>
          <p class="fm-large fm-black-cl mt-3 mb-xl-4">Designed to make storytelling natural, meaningful, and lasting</p>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="fm-white-column mt-4">
            <div class="fm-preserve-list">
              <div class="row g-5 justify-content-between">
                @for (feature of features; track feature.title) {
                  <div class="col-sm-6 col-lg-3 col-xxl-auto">
                    <div class="fm-column">
                      <img [src]="feature.image" class="img-fluid fm-pl-st" [alt]="feature.title" />
                      <h3 class="fm-cl-title my-3 fm-head-22">
                        <a href="javascript:void(0);" class="fm-title-link">{{ feature.title }}</a>
                      </h3>
                      <p class="mb-0">{{ feature.description }}</p>
                    </div>
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- How it Works Section -->
  <section id="fmHowItWorks" class="fm-guided-section fm-overlay-section">
    <div class="fm-overlay-title">
      <div class="container-xl">
        <div class="row">
          <div class="col-12 text-center">
            <div class="fm-title fm-white-title">
              <h2 class="fm-head-44"><span>Simple, Guided, Meaningful</span></h2>
            </div>
            <p class="fm-large fm-white-cl mt-3 mb-xl-4">Four steps to preserve a lifetime of memories</p>
          </div>
        </div>
      </div>
    </div>
    <div class="fm-steps-track">
      @for (step of steps; track step.number) {
        <div class="fm-steps-info">
          <a href="javascript:void(0);" class="fm-card-cl fm-card-link">
            <div class="fm-feature-image">
              <img [src]="step.image" class="img-fluid" [alt]="step.title" />
            </div>
            <div class="fm-feature-content">
              <div class="fm-icon-circle-sm">{{ step.number }}</div>
              <div class="fm-title">
                <h2 class="fm-cl-title my-3 my-xl-4 fm-head-24">{{ step.title }}</h2>
              </div>
              <p class="mb-0">{{ step.description }}</p>
            </div>
          </a>
        </div>
      }
    </div>
  </section>

  <!-- What Our Users Say Section -->
  <section class="fm-us-section fm-layout-space">
    <div class="container-xl">
      <div class="row">
        <div class="col-12 text-center">
          <div class="fm-title">
            <h2 class="fm-head-44"><span>What Our Users Say</span></h2>
          </div>
          <p class="fm-large fm-black-cl my-3">Real experiences from people preserving their most meaningful memories.</p>
        </div>
        <div class="col-12 mt-4">
          <div class="row g-4">
            @for (review of testimonials; track review.name) {
              <div class="col-md-6 col-xl-3">
                <div class="fm-border-column h-100">
                  <img src="images/homepage/quotes.svg" alt="Quotes Icon" />
                  <p class="fm-black-cl mt-3 w-100">"{{ review.quote }}"</p>
                  <hr />
                  <div class="fm-user-profile">
                    <div class="fm-userprofile">
                      <div class="fm-userprofile-image">
                        <img class="fm-profile" [src]="review.avatar" [alt]="review.name" />
                      </div>
                      <span class="fm-profile-content">
                        <p class="mb-0">{{ review.name }}</p>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- What You Can Capture Section -->
  <section class="fm-capture-section fm-layout-space fm-light-bg">
    <div class="container-xl">
      <div class="row justify-content-between align-items-center g-4">
        <div class="col-lg-5">
          <div class="fm-capture-images">
            <img src="images/homepage/capture-image.png" class="fm-feature-image img-fluid" alt="Capture Image" />
            <div class="fm-capture-frames">
              <div class="fm-frame fm-fr-top">
                <img src="images/homepage/capture-frame-img1.png" class="fm-fr-image img-fluid" alt="Capture Frame" />
              </div>
              <div class="fm-frame fm-fr-bottom">
                <img src="images/homepage/capture-frame-img2.png" class="fm-fr-image img-fluid" alt="Capture Frame" />
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-6">
          <div class="fm-title">
            <h2 class="fm-head-44"><span>What You Can Capture</span></h2>
          </div>
          <p class="fm-large fm-black-cl my-3">
            From everyday moments to life-changing milestones — capture the stories that define you and your loved ones
          </p>
          <div class="fm-tbutton-group">
            @for (tag of captureTags; track tag.label) {
              <button class="fm-tag-btn">
                <img [src]="tag.icon" class="fm-quote-icon" [alt]="tag.label + ' icon'" />
                {{ tag.label }}
              </button>
            }
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- FAQ Section -->
  <section class="fm-faq-section fm-layout-space">
    <div class="container-xl">
      <div class="row">
        <div class="col-12 text-center">
          <div class="fm-title">
            <h2 class="fm-head-44"><span>Answers to Common Questions</span></h2>
          </div>
          <p class="fm-large fm-black-cl my-3">Everything you need to know about preserving, protecting, and sharing your memories.</p>
        </div>
      </div>
      <div class="accordion fm-accordion pt-2" id="fmAccordion">
        <div class="row g-4">
          @for (faq of faqs; track faq.id; let i = $index) {
            <div class="col-lg-6">
              <div class="accordion-item fm-accordion-item">
                <h2 class="accordion-header fm-accordion-header">
                  <button
                    class="accordion-button fm-accordion-button collapsed"
                    type="button"
                    (click)="toggleFaq(faq.id)"
                    [class.collapsed]="activeFaq() !== faq.id"
                  >
                    {{ faq.question }}
                  </button>
                </h2>
                @if (activeFaq() === faq.id) {
                  <div class="accordion-collapse">
                    <div class="accordion-body fm-accordion-body">
                      <p>{{ faq.answer }}</p>
                    </div>
                  </div>
                }
              </div>
            </div>
          }
        </div>
      </div>
    </div>
  </section>

  <!-- CTA Section -->
  <section id="fmStories" class="fm-cta-section fm-layout-space fm-light-bg">
    <div class="container-xl">
      <div class="row justify-content-center text-center">
        <div class="col-lg-8">
          <div class="fm-title">
            <h2 class="fm-head-44"><span>Start Preserving Your Story Today</span></h2>
          </div>
          <p class="fm-large fm-black-cl my-3">
            Join thousands of families capturing their most precious memories for generations to come.
          </p>
          <div class="fm-btn-group justify-content-center">
            <a routerLink="/register" class="fm-common-btn">Start for Free</a>
          </div>
        </div>
      </div>
    </div>
  </section>

</div>
